export default {
      id: "common__reefer_trailer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__reefer_trailer",
      toString: function () {
        return this.url;
      }
    }